<template lang="pug">
  v-row
    v-col.pt-0
      v-container.pt-0
        div.entity-display.px-5.mb-10.div-user-comment
          v-row.pt-4
            v-col(cols="1")
              div.letterCircle {{currentUser.name.charAt(0)}}{{ currentUser.lastName.charAt(0) }}
            v-col.pt-6
              span.fullNameComment {{ currentUser.fullName }}
          v-row
            v-col(cols="12")
              g-tag-symbol(:style="{color: 'black', caretColor: 'blue',height: '100%', width: '100%', }")
                textarea.textarea-comment(
                  v-model="input",
                  :auto-grow="true",
                  :disabled="loading",
                  :rows="2",
                  flat,
                  :placeholder="$t('commentsTimeline.placeholder')",
                  outlined,
                  ref="thetext"
                )
                g-btn.primary--text.post-button(
                  icon,
                  small,
                  :disabled='loading'
                  @click="postComment"
                )
                  v-icon mdi-send
        v-timeline.pt-0(dense clipped)
          v-timeline-item.mb-1(v-for='comment in comments', :key='comment.id', color='primary', icon='mdi-circle-medium', icon-color='white', small)
            div.comment-item
              span.body-1
                | <b>{{ getUserName(comment) }}</b> &nbsp;&nbsp; <span style="color: rgba(0, 0, 0, 0.6)">  {{ getDate(comment) }}</span>
              br
              span.body-1 {{ comment.commentText }}
</template>

<style lang="scss" scoped>
  @use 'sass:color';
  .fullNameComment{
    font-size: 22px;
    font-weight: bold;
  }
  .comment-item{
    border-bottom: 1px solid lightgray;
    padding-bottom: 20px;
  }
  .div-user-comment{
    border-radius: 15px;
    background-color: var(--v-background-base) !important;
    border: 1px solid lightgray;
  }
  .textarea-comment {
    height: 65%;
    width: 100%;
    resize: none;
    overflow: hidden;
    border: 1px solid lightgray;
    padding: 15px;
    border-radius: 15px;
    background-color: white;
    &__line {
      display: block;
      border-color: grey;
      border-style: solid;
      border-width: 1px;
      transform: scale(0);
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    }
    &:focus {
      outline: none
    }
    &:focus + &__line {
      outline: none;
      transform: scale(1);
    }
  }
  .post-button{
    position:absolute;
    bottom:45px;
    right:10px;
  }
  .div2{
    display:inline-block;
    position:relative;
  }
  .letterCircle {
    border-radius: 50%;
    width: 55px;
    height: 55px;
    padding: 11px;
    background: #000077;
    color: white;
    text-align: center;
    font-size: 21px;
  }
</style>

<script>
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  props: {
    comments: {
      type: Array,
      default: () => ([]),
    },
    value: String,
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({}),

  computed: {
    input:  {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    userTz(){
      let storeTZ = _.get(this.$store.state.user, 'user.ianaTimeZone');
      return _.isEmpty(storeTZ) ? 'Etc/GMT' : storeTZ;
    },
    currentUser(){
      return this.$store.state.user.user;
    }
  },

  methods: {
    log(val) {
      console.log('INP ', this.$cleanString(val));
    },
    postComment () {
      // FIX: the value is not updated automatically when tagging someone
      // Check if the dom (source of true) has the same value, else trigger input
      if (this.$refs.thetext.value !== this.value) this.$emit('input', this.$refs.thetext.value);
      this.$emit('post');
    },
    filter() {
      return true;
    },
    dateWithFormat(comment) {
      let convertedDate =  this.$dateTimezoneConvert(comment.createdAt, 'Etc/GMT', this.userTz);
      return this.$dateFormatted(convertedDate);
    },
    getDate(comment) {
      let convertedDate = this.dateWithFormat(comment);
      return `${convertedDate}`;
    },
    getUserName(comment) {
      return `${_.get(comment, 'user.name', 'Name')} ${_.get(comment, 'user.lastName', 'Last Name')}`;
    }
  },
}
</script>
